import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/info-panel/info-panel.styles.ts
var info_panel_styles_default = r` ${component_styles_default} :host { display: block; line-height: var(--sl-line-height-normal); } .info-panel__label::part(base) { padding-bottom: var(--sl-spacing-x-small); } .info-panel__items { display: grid; grid-gap: var(--sl-spacing-x-small); } `;

export {
  info_panel_styles_default
};
